export default __webpack_public_path__ + "static/media/the-calling.86f72af1.mp3";